module.exports = __webpack_public_path__ + "img/img_shou@2x.c64673f7.png";